// Community roles — a member's standing across Circles and Networks, derived
// live from `group_memberships` joined to `groups.kind` (spaces never count).
// One list drives the server's SQL predicates (`communityRoleSql` in
// apps/server/src/groups/authz.ts), the broadcast audience filter's
// `communityRoles` facet, the user-research segments, and the web pickers.
//
//   circle_leader   leads at least one Circle
//   circle_member   member of a Circle and leads nothing (Circle or Network)
//   network_leader  leads at least one Network
//   network_member  member of a Network and leads nothing (Circle or Network)
//   individual      belongs to no Circle and no Network
export const COMMUNITY_ROLES = [
    'circle_leader',
    'circle_member',
    'network_leader',
    'network_member',
    'individual',
];
//# sourceMappingURL=community-roles.js.map